module.exports = __webpack_public_path__ + "img/icon-05.e00b5519.png";